import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=0af73315&scoped=true&"
import script from "./typelist.vue?vue&type=script&lang=js&"
export * from "./typelist.vue?vue&type=script&lang=js&"
import style0 from "./typelist.vue?vue&type=style&index=0&id=0af73315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af73315",
  null
  
)

export default component.exports